import toast from "react-hot-toast";
import axiosInstance from "../../../services/axiosInstance";

const instance = axiosInstance();

instance.defaults.baseURL += "/pursuit/docs";

export async function getPursuitDocs(pursuit_id) {
  if (!pursuit_id) return [];
  const response = await instance.get(`/get/${pursuit_id}`);
  return response.data;
}

export async function getPursuitDocsFromProposal(search_type, proposal_id) {
  if (!proposal_id || search_type === "upload") return null;
  const response = await instance.get(
    `/get-proposal/${search_type}/${proposal_id}`
  );
  return response.data;
}

export async function deletePursuitDoc(pursuit_id, doc_id) {
  const response = await instance.delete(`/delete/${pursuit_id}/${doc_id}`);
  return response.data;
}

export async function uploadPursuitDocs(files, pursuit_id) {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  formData.append("pursuit_id", pursuit_id);

  const response = await instance.post(`/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 200000,
  });

  return response.data;
}

export async function downloadPursuitDoc(doc_id, fileName) {
  if (!fileName) {
    toast.error("File name not found.");
    return;
  }
  try {
    const promise = instance.get(`/download/${doc_id}`, {
      responseType: "blob",
      timeout: 200000,
    });
    toast.promise(promise, {
      loading: "Downloading file...",
      success: "File downloaded successfully",
    });
    const response = await promise;
    // Create a URL for the downloaded file
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading the document:", error);
  }
}
